<template>
  <div class="inner-box">
    <el-form size="small">
      <div class="content-name">
        <h2 class="dp-ib">우편번호관리</h2>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- 검색조건 영역 -->
    <div class="search-form">
      <el-form size="mini" >
        <el-row style="margin-bottom: 0px;">
          <el-col :span="5">
            <el-form-item label="우편번호" label-width="120px">
              <el-input type="text" v-model="form.zipCd"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="시" label-width="120px">
              <el-input type="text" v-model="form.siNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="구" label-width="120px">
              <el-input type="text" v-model="form.guNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="동" label-width="120px">
              <el-input type="text" v-model="form.dongNm"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 테이블 -->
    <div class="talbe-contain">
      <div class="table-sub-contain"  style="width: 100%;">
        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
              ref="gridSub"
              style="width: 100%; height: 48vh; min-height: 25px;"
              class="ag-theme-alpine"
              :enableRangeSelection="true"
              :columnDefs="columnDefsSub"
              :defaultColDef="defaultColDefSub"
              :frameworkComponents="frameworkComponents"
              :rowData="subData"
              :gridOptions="gridOptionsSub"
              :suppressRowClickSelection="false"
              :statusBar="statusBar"
              @grid-ready="onReadyMain"
              @cell-clicked="onCellClickedSub"
            />
          </div>
        </div>
        <div class="table-header">
          <el-form style="display: grid; float: right;" size="small">
            <el-form-item label-width="0px">
              <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
              <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
              <el-button type="danger" icon="el-icon-delete" v-if="form.zipId != ''"  @click="deleteZip">삭제</el-button>
            </el-form-item>
          </el-form>
        </div>
        <zip-info ref="zipInfo"  :zipDetail="zipDetail" style="height: 100%"/>

      </div> <!-- table sub contain -->
    </div> <!-- table contain -->
  </div>


</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
import ZipInfo from "@/components/InfoManage/ZipInfo.vue";

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
    String(x || "")
      .trim()
      .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "zip",
  components: {ZipInfo, parent},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      form: {
        zipKey: "",
        zipNm: "",
        zipId: "",
        parentId: "",
        TopKey: "",
        zipIdx: "",
        description: "",
        zipCd: "",
        siNm: "",
        guNm: "",
        dongNm: "",
        riNm: "",
        islandNm: "",
        bunji: "",
        buildingNm: "",
      },
      defForm: {
        zipKey: "",
        zipNm: "",
        zipId: "",
        parentId: "",
        TopKey: "",
        zipIdx: "",
        description: "",
        zipCd: "",
        siNm: "",
        guNm: "",
        dongNm: "",
        riNm: "",
        islandNm: "",
        bunji: "",
        buildingNm: "",
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      zipDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autozipColumnDef: null,
      rowModelType: null,
      isServerSidezipOpenByDefault: null,
      isServerSidezip: null,
      getServerSidezipKey: null,
      selectId : "",
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

      this.$store.commit('loading')
      this.$http
        .post("/api/zipMng/list", {
          companyId: this.$store.state.loginInfo.compCd,
          zipCd : "",
          siNm : "",
          guNm : "",
          dongNm : "",
          sortType : true,
          page : 1,
          totalPage : 999999,
          totalCount : 999999,
          curPage : 0,
          processTime : ""
        })
        .then(response => {
          this.subData = response.data
        }).finally(() => {
        this.$store.commit('finish')
      });
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autozipColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSidezipOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSidezip = (dataItem) => {
        // indizipe if node is a zip
        //console.log(dataItem);
        return dataItem.zip;
      };
      this.getServerSidezipKey = (dataItem) => {
        // specify which zip key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {headerName:'우편번호', field:'zipCd',width:100, editable:false},
        {headerName:'시명', field:'siNm',width:100, editable:false},
        {headerName:'구명', field:'guNm',width:100, editable:false},
        {headerName:'동명', field:'dongNm',width:100, editable:false},
        {headerName:'동상세', field:'dongDetail',width:200, editable:false,
          valueFormatter: function(params) {
            return params.data.riNm + ' ' + params.data.islandNm + ' ' + params.data.bunji + ' ' + params.data.buildingNm;
          }
        },
        {headerName:'', field:'riNm', hide : true},
        {headerName:'', field:'islandNm', hide : true},
        {headerName:'', field:'buildingNm', hide : true},
        {headerName:'', field:'zipId', hide : true},
      ]
    },
    //Main 그리드 SelctionChange 발생
    onSelectionChangedMain(event) {
      // const voRow = this.gridApi.getSelectedRows() //선택된 Row
      // this.zipDetail = this.defForm;
      // this.parentNm = voRow[0].menu_nm;
      // this.$store.commit('loading')
      // this.$http
      //   .post("/api/zip/detail", {
      //     companyId: this.$store.state.loginInfo.compCd,
      //     parentId: voRow[0].menu_id,
      //     sortType : true,
      //     page : 1,
      //     totalPage : 9999,
      //     totalCount : 9999,
      //     curPage : 0,
      //     processTime : ""
      //   })
      //   .then(response => {
      //     this.subData = response.data
      //     this.selectId = voRow[0].menu_id;
      //   }).finally(() => {
      //   this.$store.commit('finish')
      // });
    },
    onCellClickedSub(params) {
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      const voRow = params.data //선택된 Row
      this.form = []; // 초기화
      this.zipDetail = voRow;
    },
    goOpen() {

      this.$store.commit('loading')
      this.$http
        .post("/api/zipMng/list", {
          companyId: this.$store.state.loginInfo.compCd,
          zipCd : this.form.zipCd == undefined ? '' : this.form.zipCd,
          siNm : this.isEmpty(this.form.siNm) == '' ? '' : this.form.siNm,
          guNm : this.isEmpty(this.form.guNm) == '' ? '' : this.form.guNm,
          dongNm : this.isEmpty(this.form.dongNm) == '' ? '' : this.form.dongNm,
          sortType : true,
          page : 1,
          totalPage : 999999,
          totalCount : 999999,
          curPage : 0,
          processTime : ""
        })
        .then(response => {
          this.subData = response.data
        }).finally(() => {
        this.$store.commit('finish')
      });

    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    save() {
      const zipInfo = JSON.parse(JSON.stringify(this.$refs.zipInfo.form));
      if(!this.gridRequireCheck([this.$refs.gridSub ])) return;

      // 비어있다면 생성 , 비어있지 않다면 수정
      if(zipInfo.zipId == ""){

        this.$http
          .put('/api/zipMng/save',{
            companyId: this.$store.state.loginInfo.compCd,
            zipCd: zipInfo.zipCd,
            zipId: 0,
            siNm: zipInfo.siNm,
            guNm: zipInfo.guNm,
            dongNm: zipInfo.dongNm,
            riNm: zipInfo.riNm,
            islandNm: zipInfo.islandNm,
            bunji: zipInfo.bunji,
            buildingNm: zipInfo.buildingNm,
            description: zipInfo.description,
            creatorId: this.$store.state.loginInfo.id,
            processTime: "",
          })
          .then(response => {
            this.$swal({ type: 'success', text: '저장되었습니다.' });
            // this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
      }else{
        //수정 시작

        this.$http
          .put('/api/zipMng/update',{
            companyId: this.$store.state.loginInfo.compCd,
            zipCd: zipInfo.zipCd,
            zipId: zipInfo.zipId,
            siNm: zipInfo.siNm,
            guNm: zipInfo.guNm,
            dongNm: zipInfo.dongNm,
            riNm: zipInfo.riNm,
            islandNm: zipInfo.islandNm,
            bunji: zipInfo.bunji,
            buildingNm: zipInfo.buildingNm,
            description: zipInfo.description,
            updatorId: this.$store.state.loginInfo.id,
            processTime: "",
          })
          .then(response => {
            this.$swal({ type: 'success', text: '수정되었습니다.' });
            // this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
      }


    },
    deleteZip() {

      const zipInfo = JSON.parse(JSON.stringify(this.$refs.zipInfo.form));
      if(!this.gridRequireCheck([this.$refs.gridSub ])) return;

      this.$swal({
        type: 'info',
        text: `선택한 우편번호를 삭제하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$http
              .put('/api/zipMng/delete', {
                companyId: this.$store.state.loginInfo.compCd,
                zipId: zipInfo.zipId,
                updatorId: this.$store.state.loginInfo.id,
                processTime: "",
              })
              .then(response => {
                this.$swal({type: 'success', text: '삭제되었습니다.'});
                // this.goOpen();
              })
              .catch(({message}) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({type: "error", text: "오류가 발생했습니다."});
                }
              });
        }
      })

    },
    addRowd() {
      try{

        const row = this.gridApi.getSelectedNodes()

        if(row.length < 1)
          throw '그룹코드가 선택되지 않았습니다.'

        const idx = row[0].rowIndex

        this.subData.push({
          detailCd: "",
          detailNm: "",
          useYn: "Y",
          orderSeq: "",
          remark1: "",
          remark2: "",
          remark3: "",
          remark4: "",
          remark5: "",
          detailDesc: "",
          parent_id: this.data[0].inner_menu[idx-1].parent_id,
          compCd: this.$store.state.loginInfo.compCd,
        });
      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    cancel(){
      // zipInfo 초기화
      this.$refs.zipInfo.form = _.clone(this.defForm);
      this.form = _.clone(this.defForm);
    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(zipKeys, data) {
            if (zipKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0? false : true;
                return {
                  zip:  has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                };
              });
            }
            var key = zipKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                  zipKeys.slice(1),
                  data[i].inner_menu.slice()
                );
              }
            }
          }
          return extractRowsFromData(request.zipKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {
          //console.log('ServerSideDatasource.getRows: params = ', params);

          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
            ? {
              rowData: allRows.slice(request.startRow, request.endRow),
              rowCount: allRows.length,
            }
            : { rowData: allRows };
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
};

</script>